import { auth } from "../firebase";

export async function postChatMessage({ uid, tab, message, pip = false }) {

  try {
    if (!auth.currentUser) {
      throw new Error("Not authenticated");
    }

    const token = await auth.currentUser.getIdToken();

    const now = new Date();
    const hours = String(now.getUTCHours()).padStart(2, "0");
    const minutes = String(now.getUTCMinutes()).padStart(2, "0");
    const chatCurrentTime = `[${hours}:${minutes}]`;

    const payload = {
      UID: uid,
      chatMessage: message,
      chatToChannel: tab,
      chatCommand: false,
      chatPIP: pip,
      chatCurrentTime,
      chatTimestamp: Date.now()
    };


    const response = await fetch(
      "https://postchatmessage-5dhfwyjvzq-uc.a.run.app",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(payload)
      }
    );


    if (!response.ok) {
      const errText = await response.text();
      throw new Error(`Chat post failed: ${errText}`);
    }

    const data = await response.json();
    return data;
  } catch (err) {
    throw err;
  }
}
